import api from "../configurations/axios";
import ActiveCompetitionsResponse from "../responses/ActiveCompetitionsResponse";
import CompetitionDetailsResponse from "../responses/CompetitionDetailsResponse";
import CompetitionTicketPurchasedByUserResponse from "../responses/CompetitionTicketPurchasedByUserResponse";
import endedCompetitionsWithoutWinnersResponse from '../responses/EndedCompetitionsWithoutWinnersResponse';
import competitionDropdownResponse from '../responses/CompetitionsDropdownResponse';
import CompetitionDetailsPostalEntry from "../models/CompetitionDetailsPostalEntry";
import { formatDateTime } from "../utils/datetime-helper";
import CompetitionListResponse from "../responses/CompetitionListResponse";

class CompetitionService{
    async getAllCompetitions() {
        try {
            const response = await api.get<competitionDropdownResponse[]>("/api/competitions/all");
            return response.data;
        } catch (error) {            
            console.error("error:", error.response?.data || error.message);
        }
    }

    async getActiveCompetitions() {
        try {
            const response = await api.get<ActiveCompetitionsResponse[]>("/api/competitions/active");
            return response.data;
        } catch (error) {            
            console.error("error:", error.response?.data || error.message);
        }
    }

    async getEndedCompetitionsWithoutWinners() {
        try {
            const response = await api.get<endedCompetitionsWithoutWinnersResponse[]>("/api/competitions/ended-competitions-without-winners");
            return response.data;
        } catch (error) {            
            console.error("error:", error.response?.data || error.message);
        }
    }

    async getCompetitionById(competitionId: number) {
        try {
            const response = await api.get<CompetitionDetailsResponse>(`/api/competitions/${competitionId}/info`);
            return response.data;
        } catch (error) {
            console.error("error:", error.response?.data || error.message);
        }
    }

    async getCompetitionTicketPurchasedByUser(competitionId: number, userId: number) {
        try {
            const response = await api.get<CompetitionTicketPurchasedByUserResponse>(`/api/competitions/${competitionId}?userid=${userId}`);
            return response.data;
        } catch (error) {
            console.error("error:", error.response?.data || error.message);
        }
    }

    async getCompetitionDetailsForPostalEntry(competitionId: number, userId: number): Promise<CompetitionDetailsPostalEntry> {
        try {
            const competitionDetails = await this.getCompetitionById(competitionId);
            const competitionTicketPurchasedByUser = await this.getCompetitionTicketPurchasedByUser(competitionId, userId);

            const competitionDetailsPostalEntry: CompetitionDetailsPostalEntry = {
                competitionId: competitionDetails.competitionId,
                competitionName: competitionDetails.competitionName,
                startDate: formatDateTime(competitionDetails.startDate.toString()),
                endDate: formatDateTime(competitionDetails.endDate.toString()),
                ticketLimit: competitionDetails.ticketCount,
                ticketsSold: competitionDetails.totalTicketsSold,
                ticketsAvailable: competitionDetails.ticketCount - competitionDetails.totalTicketsSold,
                userTicketCap: competitionDetails.userTicketCap,
                ticketsPurchasedByUser: competitionTicketPurchasedByUser.ticketsPurchased,
                ticketsAvailableToUser: competitionDetails.userTicketCap - competitionTicketPurchasedByUser.ticketsPurchased,
            };

            return competitionDetailsPostalEntry;
        } catch (error) {
            console.error("error:", error.response?.data || error.message);
        }
    }

    async addPostalEntry(userId: number, competitionId: number) {
        try {
            const response = await api.post('/api/competitions/entries/postal', {userId, competitionId});
            return response;
        } catch (error) {
            throw error; 
        }
    }

    async getCompetitionList() {
        try {
            const response = await api.get<CompetitionListResponse[]>("/api/competitions/list");
            return response.data;
        } catch (error) {
            console.error("error:", error.response?.data || error.message);
        }
    }
}

export default new CompetitionService();